import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import CustomDateRanges from "./smartComponents/CustomDateRanges";
import DatePicker from "./smartComponents/DatePicker";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import { actionCreators } from "./redux/averageNumberOfVisitsPerClientSagas";
import KBLearnMore from "../../../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../../../constants/ilearnUrls";
import { UpdateButtons } from "./smartComponents/UpdateButtons";
import GroupBy from "./smartComponents/GroupBy";
import LineOrTableChart from "./smartComponents/LineOrTableChart";
import OnlyMembership from "./smartComponents/OnlyMembership";
import ScoreCards from "./smartComponents/ScoreCards";
import CategoriesFilter from "./smartComponents/CategoriesFilter";
import Type from "./smartComponents/Type";
import MembershipTypes from "./smartComponents/MembershipTypes";
import AverageBreakdown from "./smartComponents/AverageBreakdown";
import "../../attendance_common.css.scss";
import "./averageNumberOfVisitsPerClient.scss";

const AverageNumberOfVisitsPerClientModule = (props) => {
  const { useSecondaryCategories } = useSelector((state) => state.commonReducer.commonProps);
  const {
    isLoading,
    initialRequest,
    updatesLoading,
    chartLoading,
    isFiltersLoading,
    primaryCategoriesLoading,
    secondaryCategoriesLoading,
    pricingOptionsLoading,
    filters,
    selectedFilters,
    selectedFilters: { type }
  } = useSelector((state) => state.averageNumberOfVisitsPerClient);

  const dispatch = useDispatch();
  useEffect(() => {
    !initialRequest &&
      dispatch(actionCreators.fetchCurrentUser({ ...props, useSecondaryCategories }));
  }, []);
  const content = () => {
    return (
      <div>
        <div id="override-edit-selection-bar" className="edit-selections-bar">
          <div className="top-filter">
            <div className={`top-left-filter ${useSecondaryCategories ? "" : "extend"}`}>
              <div className="select-box-no-width" style={{ width: "170px", maxWidth: "170px" }}>
                <p>View</p>
                <Type />
              </div>
              {type.id === "membership_type" ? (
                <div className="select-box" style={{ maxWidth: "170px" }}>
                  <p>Membership Type</p>
                  {isFiltersLoading ? <LoadingAnimation uiLoader /> : <MembershipTypes />}
                </div>
              ) : (
                <>
                  {useSecondaryCategories && (
                    <CategoriesFilter
                      selected={selectedFilters.primary_categories}
                      options={filters.primary_categories}
                      action="updatePrimaryCategory"
                      loader={isFiltersLoading || primaryCategoriesLoading}
                      name="Primary Category"
                    />
                  )}
                  <CategoriesFilter
                    selected={selectedFilters.secondary_categories}
                    options={filters.secondary_categories}
                    action="updateSecondaryCategory"
                    loader={isFiltersLoading || secondaryCategoriesLoading}
                    name={`${useSecondaryCategories ? "Secondary" : ""} Category`}
                  />
                  <CategoriesFilter
                    selected={selectedFilters.pricing_options}
                    options={filters.pricing_options}
                    action="updatePricingOption"
                    loader={isFiltersLoading || pricingOptionsLoading}
                    name="Sales Package"
                  />
                  <div className="select-box-no-width">
                    <p>Group By</p>
                    <GroupBy />
                  </div>
                  <div className="select-box-no-width">
                    <p>Show Membership Only </p>
                    <OnlyMembership />
                  </div>
                </>
              )}
            </div>
            <div className="top-filter__right">
              <UpdateButtons />
            </div>
          </div>
          <div className="bottom-filter">
            <div className="select-box-no-width date-range-select-box">
              <p>Date Range</p>
              <CustomDateRanges />
            </div>
            <div className="date-select-box monthly" style={{ width: "250px" }}>
              <p>Date</p>
              <DatePicker />
            </div>
          </div>
        </div>

        <div data-testid="charts-container" className="chart-root">
          {updatesLoading ? (
            <LoadingAnimation text="Updating data..." />
          ) : (
            <>
              {selectedFilters.only_memberships &&
              !selectedFilters.primary_categories.length &&
              !selectedFilters.secondary_categories.length ? (
                <div className="error error--big">No Membership Visits</div>
              ) : (
                <>
                  <ScoreCards />
                  <AverageBreakdown />
                  {chartLoading ? (
                    <LoadingAnimation text="Updating chart..." />
                  ) : (
                    <LineOrTableChart />
                  )}
                </>
              )}
            </>
          )}
        </div>
      </div>
    );
  };
  const title = "Average Number of Visits";
  return (
    <div id="attendance-root">
      <SectionToggle
        height={690}
        title={title}
        isLoading={isLoading}
        learnMore={<KBLearnMore {...learnMoreProps(props.clientName)} />}
        content={content()}
      />
    </div>
  );
};

const learnMoreProps = (clientName) => {
  const name = clientName?.toLowerCase();
  const singular = name?.replace(/s$/, "");
  return {
    title: "Average Number of Visits",
    description: `This report shows the average visit frequency per ${singular} for the selected timeframe. These insights help you understand engagement intensity, spot declining activity early, and evaluate how often ${name} interact with your services.`,
    kbUrl: ILEARN_URLS.attendance.averageNumberOfVisits,
    customStyles: { width: "660px" }
  };
};
export default React.memo(AverageNumberOfVisitsPerClientModule);

AverageNumberOfVisitsPerClientModule.propTypes = {
  params: PropTypes.object,
  useSecondaryCategories: PropTypes.bool,
  clientName: PropTypes.string
};
